import { Options } from '@components/modules/Table/types'
import { route } from '@helpers'
import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router'
import { Row } from 'react-table'

export default function useTableOptions() {
    const history = useHistory()

    const edit = useCallback((row: Row<Interfaces.Salon>) => history.push(route("admin:salon", row.original.id)), [])
    const add = useCallback(() => history.push(route("admin:salons:add")), [])

    const options: Options<Interfaces.Salon> = useMemo(() => ({
        actions: [{ label: "Manage", action: edit }],
        add
    }), [])

    return options
}